import ProductSize from '../product-size';
import Material from '../../material/material';
import PlacementType from './placement-type';
import BoardType from './board-type';
import { SignConstructionRequirement } from './sign-construction-requirement';

export class SignSize extends ProductSize {
  placementType: PlacementType;
  boardType: BoardType;
  material: Material;

  nbInstallersRequired: number;

  transportPrice: string;
  paintedPostsPrice: string;
  removalPrice: string;
  productionRetailPrice: string;
  placementRetailPrice: string;
  recyclePrice: string;

  cmToBottom: number;
  removalMinutes: number;

  requiredConstructionMaterials: SignConstructionRequirement[];
  uploadedAssetUuids: string[];

  constructor() {
    super();
    this.type = 'SignSize';
    this.requiredConstructionMaterials = [];
    this.uploadedAssetUuids = [];
  }
}

export enum PlacementInvoiceAutoFillPriceField {
  PRODUCTION_PRICE = 'productionPrice',
  PRODUCTION_RETAIL_PRICE = 'productionRetailPrice',
  PLACEMENT_PRICE = 'placementPrice',
  PLACEMENT_RETAIL_PRICE = 'placementRetailPrice',
  PAINTED_POSTS_PRICE = 'paintedPostsPrice',
  REMOVAL_PRICE = 'removalPrice'
}
